import { render } from "./SystemDialog.vue?vue&type=template&id=ef8f1672"
import script from "./SystemDialog.vue?vue&type=script&lang=js"
export * from "./SystemDialog.vue?vue&type=script&lang=js"

import "./SystemDialog.vue?vue&type=style&index=0&id=ef8f1672&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__